module.exports = __webpack_public_path__ + "img/2200_keytakeaways_header.9d4c2fe2.png";